import { resolveAccountPhotoUrl } from "./profilePhoto/cropMath.js";

/**
 * Presentation only: DEV Act As retains the controller's authenticated fields.
 * Never resolve either person's photo while acting, or change that shared identity.
 */
export function accountPresentation(user) {
  const isActing = Boolean(user?.devActAs);
  const person = user?.devActAs?.person;
  const displayName = isActing ? person?.displayName ?? user?.display_name : user?.display_name;
  const email = isActing ? person?.email ?? user?.email : user?.email;
  return {
    isActing,
    displayName,
    email,
    identity: isActing ? person?.id ?? email : user?.id ?? user?.okta_sub ?? email,
    photoUrl: isActing ? null : resolveAccountPhotoUrl(user),
  };
}
